import { Typography } from "PFComponents/typography";
import { convertToPercentage } from "PFCore/utilities/math";

type PercentageValueProps = {
  value: string | number | undefined | null;
  isNormalized?: boolean;
};

export const PercentageValue = ({ value, isNormalized }: PercentageValueProps) => (
  <Typography variant="bodyRegular" tag="span">
    {convertToPercentage(value, { isNormalized })}
  </Typography>
);
